import styled from "styled-components";
import { shade850 } from "../../../styles/tokens";

// TEXT

// STYLES
export const DropdownDivider = styled.hr.attrs(() => ({
  role: "separator",
}))`
  background: ${shade850};
  height: 0.0625rem;
  width: 100%;
  border: none;
  margin: 0;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
